export const API_BASE_URL = "https://api.servall.in";
// export const API_BASE_URL = "http://localhost:5000";
export const MEDIA_URL = "https://servall-storage.s3.ap-south-1.amazonaws.com";

/** Full URLs are used as-is. Relative paths get the media host. */
export function getMediaUrl(path) {
  if (!path) return "";
  let value = String(path).trim();
  const httpAt = value.search(/https?:\/\//i);
  if (httpAt > 0) value = value.slice(httpAt);
  if (/^https?:\/\//i.test(value)) return value;
  const base = MEDIA_URL.replace(/\/$/, "");
  return value.startsWith("/") ? `${base}${value}` : `${base}/${value}`;
}

export const ApiEndPoints = {
  AUTH: {
    login: `${API_BASE_URL}/api/v1/admin/auth/login`,
    me: `${API_BASE_URL}/api/v1/admin/auth/me`,
    forgot: `${API_BASE_URL}/api/v1/admin/auth/forgot/password`,
    verifyotp: `${API_BASE_URL}/api/v1/admin/auth/verify/otp`,
    reset: `${API_BASE_URL}/api/v1/admin/auth/reset/password`,
    resendotp: `${API_BASE_URL}/api/v1/admin/auth/resend/otp`,
  },
  DASHBOARD: {
    count: `${API_BASE_URL}/api/v1/admin/website/dashboard`,
  },
  SERVICE: {
    list: `${API_BASE_URL}/api/v1/admin/website/services`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/website/services/${id}`,
    refund: (id) => `${API_BASE_URL}/api/v1/admin/website/services/${id}/refund`,
  },
  AMC_ORDERS: {
    list: `${API_BASE_URL}/api/v1/admin/website/amc-orders`,
    update: (id) => `${API_BASE_URL}/api/v1/admin/website/amc-orders/${id}`,
    refund: (id) => `${API_BASE_URL}/api/v1/admin/website/amc-orders/${id}/refund`,
  },
  INQUIRY: {
    list: `${API_BASE_URL}/api/v1/admin/website/inquiry`,
  },
  CONTACT: {
    list: `${API_BASE_URL}/api/v1/admin/website/contacts`,
  },
  HOME_DETAILS: {
    list: `${API_BASE_URL}/api/v1/admin/home`,
    edit: `${API_BASE_URL}/api/v1/admin/home/upsert`,
  },
  PERFORMAX: {
    list: `${API_BASE_URL}/api/v1/admin/performax`,
    create: `${API_BASE_URL}/api/v1/admin/performax`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/performax/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/performax/${id}`,
  },
  GALLERY: {
    list: `${API_BASE_URL}/api/v1/admin/gallery`,
    create: `${API_BASE_URL}/api/v1/admin/gallery`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/gallery/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/gallery/${id}`,
  },
  WORKSHOP: {
    list: `${API_BASE_URL}/api/v1/admin/workshop`,
    create: `${API_BASE_URL}/api/v1/admin/workshop`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/workshop/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/workshop/${id}`,
  },
  BANNER: {
    list: `${API_BASE_URL}/api/v1/admin/banner/all`,
    edit: `${API_BASE_URL}/api/v1/admin/banner/upsert`,
  },
  BULK_ORDER: {
    list: `${API_BASE_URL}/api/v1/admin/website/bulk-orders`,
  },
  MISC: {
    cities: `${API_BASE_URL}/api/v1/misc/workshop/cities`,
  },
  BLOG: {
    list: `${API_BASE_URL}/api/v1/admin/blog`,
    create: `${API_BASE_URL}/api/v1/admin/blog`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/blog/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/blog/${id}`,
  },
  SEO: {
    list: `${API_BASE_URL}/api/v1/admin/seo`,
    create: `${API_BASE_URL}/api/v1/admin/seo`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/seo/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/seo/${id}`,
  },
  TESTIMONIALS: {
    list: `${API_BASE_URL}/api/v1/admin/testimonial`,
    create: `${API_BASE_URL}/api/v1/admin/testimonial`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/testimonial/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/testimonial/${id}`,
  },
  SERVICE_TYPES: {
    list: `${API_BASE_URL}/api/v1/admin/service-types`,
    create: `${API_BASE_URL}/api/v1/admin/service-types`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/service-types/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/service-types/${id}`,
  },
  AMC_PACKAGES: {
    list: `${API_BASE_URL}/api/v1/admin/amc-packages`,
    create: `${API_BASE_URL}/api/v1/admin/amc-packages`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/amc-packages/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/amc-packages/${id}`,
  },
  FAQS: {
    list: `${API_BASE_URL}/api/v1/admin/faq`,
    create: `${API_BASE_URL}/api/v1/admin/faq`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/faq/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/faq/${id}`,
  },
  WEBSITE_CONFIG: {
    config: `${API_BASE_URL}/api/v1/admin/website-config`,
    uploadImage: `${API_BASE_URL}/api/v1/admin/website-config/upload-image`,
  },
  SETTINGS: {
    get: `${API_BASE_URL}/api/v1/admin/settings`,
    update: `${API_BASE_URL}/api/v1/admin/settings`,
  },
};
